import React from 'react';

import classNames from 'classnames';

import { FxFootnote } from '../../ShowInSelect';

import ProjectColumnsTable from './ProjectColumnsTable';
import ProjectRowsTable from './ProjectRowsTable';

import CheckboxInput from 'CommonComponents/CheckboxInput';

export const LAYOUT_ROWS = 'rows';
export const LAYOUT_COLUMNS = 'columns';

const layoutOptions = () => [
    { id: LAYOUT_ROWS, label: $t('Projects as rows') },
    { id: LAYOUT_COLUMNS, label: $t('Projects as columns') },
];

function LayoutToggle({ value, onChange }) {
    return (
        <div className="tw-inline-flex tw-rounded-full tw-border-2 tw-border-blue tw-overflow-hidden" role="group" aria-label={$t('Layout')}>
            {layoutOptions().map((option) => (
                <button
                    key={option.id}
                    type="button"
                    aria-pressed={value === option.id}
                    onClick={() => onChange(option.id)}
                    className={classNames('tw-px-4 tw-py-1 tw-text-sm tw-font-medium tw-transition-colors', {
                        'tw-bg-blue tw-text-white': value === option.id,
                        'tw-bg-white tw-text-blue': value !== option.id,
                    })}
                >
                    {option.label}
                </button>
            ))}
        </div>
    );
}

/**
 * The By project tab: the layout toggle, "Expand departments" (projects open
 * to departments in the rows layout, departments to cost centres in the
 * columns layout), the committed and actuals toggle, and the table.
 */
export default function ByProjectTab({
    report,
    fx,
    fxAvailable = false,
    loading,
    layout,
    onChangeLayout,
    committedActuals,
    onChangeCommittedActuals,
    expanded,
    onToggle,
    allExpanded,
    canExpand,
    onExpandAll,
}) {
    return (
        <div className="tw-space-y-4">
            <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-6 tw-gap-y-2">
                <LayoutToggle value={layout} onChange={onChangeLayout} />
                <div className="tw-text-sm tw-text-charcoal">
                    <CheckboxInput
                        label={$t('Expand departments')}
                        checked={allExpanded}
                        disabled={!canExpand}
                        onChange={(event) => onExpandAll(event.target.checked)}
                    />
                </div>
                <div className="tw-text-sm tw-text-charcoal">
                    <CheckboxInput
                        label={$t('Include committed and actuals to date')}
                        checked={committedActuals}
                        onChange={(event) => onChangeCommittedActuals(event.target.checked)}
                    />
                </div>
            </div>

            {loading && !report && <p className="tw-text-sm tw-text-charcoal-75 tw-mb-0">{$t('Loading…')}</p>}

            {report &&
                (layout === LAYOUT_COLUMNS ? (
                    <ProjectColumnsTable report={report} fx={fx} committedActuals={committedActuals} expanded={expanded} onToggle={onToggle} />
                ) : (
                    <ProjectRowsTable report={report} fx={fx} committedActuals={committedActuals} expanded={expanded} onToggle={onToggle} />
                ))}

            {report && fxAvailable && <FxFootnote fx={fx} />}
        </div>
    );
}
